<template>

    <LayoutDefault>

       <b-row class="fuid-login">

            <b-col cols="12 fuid-login_error">

                <errorFromServer
                    :id="id"
                />

            </b-col>

            <b-col cols="12"
                class="fuid-form-group"
                :class="{ 'form-group--error': $v.fields.name.$error }"
            >

                <label class="fuid-form__label">{{$t('login.email')}}</label>
                <input class="fuid-form__input" v-model="fields.name" />

                <div class="error" v-if="!$v.fields.name.required">{{$t('forms.required')}}</div>

            </b-col>

            <b-col cols="12"
                class="fuid-form-group"
                :class="{ 'form-group--error': $v.fields.password.$error }"
            >

                <label class="fuid-form__label">{{$t('login.password')}}</label>
                <input class="fuid-form__input" v-model="fields.password" type="password" />

                <div class="error" v-if="!$v.fields.password.required">{{$t('forms.required')}}</div>

            </b-col>

            <b-col cols="12 d-lg-flex justify-content-between align-items-center fuid-form__actions">

                <button class="fuid-button fuid-button-step align-items-center" @click.prevent="login()">
                    
                    <b-spinner v-if="loading" variant="light" label="Loading..."></b-spinner>
                    <span v-else>{{$t('login.login')}}</span>
                    
                </button>

                <router-link class="fuid-login__forget" :to="`/${$i18n.locale}/olvido-contrasena`">{{$t('login.forget')}}</router-link>

            </b-col>

        </b-row>

    </LayoutDefault>

</template>

<script>

    import { mapActions } from 'vuex'
    import { mapGetters } from 'vuex'

    import { required } from 'vuelidate/lib/validators'
    import scrollTo from '@/mixins/scrollTo'
    import LayoutDefault from '@/components/layouts/LayoutDefault'
    import errorFromServer from '@/components/errorFromServer'

    export default {

        data() {

            return {

                id: 1,
                logged: false,
                loading: false,
                validation_form: false,
                fields: {

                    name: '',
                    password: ''

                }

            }

        },

        components: {

            LayoutDefault,
            errorFromServer

        },

        mixins: [scrollTo],

        validations: {

            fields: {

                name: {
                    required
                },
                password: {
                    required
                }

            }

        },

        methods: {

            ...mapActions('Login', ['loginUser']),
            ...mapActions('Login', ['getPersonaLogged']),

            /*
            * Send user data
            *
            */
           
            async login () {

                this.$v.$touch()

                if (this.$v.$invalid) {
                    
                    this.validation_form = false

                } else {
                    
                    this.validation_form = true

                    this.loading = true

                    let logToken = await this.loginUser( { username: this.fields.name, password: this.fields.password, componentId: this.id } )
                    let logPersona = false

                    if( logToken ) {

                        logPersona = await this.getPersonaLogged( { componentId: this.id } )

                    }

                    this.loading = false

                    if( logToken && logPersona ) {

                        this.$router.push(`/${this.$i18n.locale}/home`)

                    } else {

                        this.scrollToError()

                    }

                }

            },

            /*
            * Empty login form
            *
            */
           resetForm() {

                this.fields.name = '';
                this.fields.password = '';

           }

        }
        
    }

</script>